export class WrongFileTypeException extends Error {
  constructor(m: string) {
    super(m);
    Object.setPrototypeOf(this, WrongFileTypeException.prototype);
  }
}
